/**
 *  This file was to define all public and internal events
 */
/** @hidden */
export const load = 'load';
/** @hidden */
export const rowDataBound = 'rowDataBound';
/** @hidden */
export const queryCellInfo = 'queryCellInfo';
/** @hidden */
export const toolbarClick = 'toolbarClick';
/** @hidden */
export const keyPressed = 'key-pressed';
